module.exports = __webpack_public_path__ + "img/increase-confidence.870bbbc2.svg";